import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalsService } from 'modal';
import { SUPPORTED_LANGUAGES } from 'utils';

@Injectable({
  providedIn: 'root',
})
export class LandingPagesGuard implements CanDeactivate<unknown> {
  private modalsService = inject(ModalsService);

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const langs = Object.keys(SUPPORTED_LANGUAGES);

    if (!nextState.url.split('/').some(urlPart => langs.includes(urlPart))) {
      return true;
    }

    return this.modalsService.openConfirmationDialogIfAny();
  }
}
